import { z } from 'zod';
import { SubscriptionSchema } from './subscription.model';
import { subscriptionPaymentMethodPublicSchema } from './subscription.payment-method.model';

/**
 * API-safe subscription shape — `paymentMethod.token` is never exposed.
 */
export const subscriptionPublicSchema = SubscriptionSchema.model.extend({
  paymentMethod: subscriptionPaymentMethodPublicSchema.optional(),
});

export type SubscriptionPublic = z.infer<typeof subscriptionPublicSchema>;
